<template>
  <div class="help-help">
    <div class="help-steps">
      <div class="steps-title">{{ $t("help.DAPP") }}</div>
      <div class="steps-button">
        <div @click="changeStepsStatus('1')" :class="stepsStatus == '1' ? 'steps-active' : ''">
          <p>1</p>
        </div>
        <div @click="changeStepsStatus('2')" :class="stepsStatus == '2' ? 'steps-active' : ''">
          <p>2</p>
        </div>
        <div @click="changeStepsStatus('3')" :class="stepsStatus == '3' ? 'steps-active' : ''">
          <p>3</p>
        </div>
        <div @click="changeStepsStatus('4')" :class="stepsStatus == '4' ? 'steps-active' : ''">
          <p>4</p>
        </div>
        <div @click="changeStepsStatus('5')" :class="stepsStatus == '5' ? 'steps-active' : ''">
          <p>5</p>
        </div>
      </div>
      <div class="steps-five" v-if="stepsStatus == '3'">
        <div class="four-tips">
          <div class="steps-three">
            <div>A：{{ $t("help.a") }}</div>
            <div>
              B：{{ $t("help.b") }}
            </div>
            <div>{{ $t("help.Focus_on") }}</div>
          </div>
        </div>
      </div>
      <div class="steps-five" v-if="stepsStatus == '4'">
        <div class="success" style="color: #ffffff">
          {{ $t("help.login") }}
        </div>
        <div class="success" style="padding-bottom: 1.25rem">
          {{ $t("help.hash") }}
        </div>
        <div class="four-tips">
          <div class="login" @click="toLink('https://tronscan.io/')">
            <p>{{ $t("help.login_website") }}</p>
          </div>
          <div class="steps-four">
            {{ $t("help.you") }}
            <p @click="toLink('https://tronscan.io/')">Https：//Tronscan.Io</p>
            {{ $t("help.query") }}
            。
          </div>
        </div>
      </div>
      <div class="steps-five" v-if="stepsStatus == '5'">
        <div class="success" style="color: #ffffff">{{ $t("help.congratulations") }}！</div>
        <div class="success" style="padding-bottom: 1.25rem">
          {{ $t("help.winning") }}
        </div>
        <div class="tips">
          <div>{{ $t("help.address") }}</div>
        </div>
      </div>
      <div class="steps-first" v-if="stepsStatus == '2'">
        <div class="register" style="color: #ffffff">
          {{ $t("help.number") }}
        </div>
        <div class="register">{{ $t("help.skip") }}</div>
        <div class="com-title">
          {{ $t("help.Digital_currency") }}
        </div>
        <div class="form-data">
          <div class="form-top">
            <div>
              <p>{{ $t("help.platform") }}</p>
            </div>
            <div>
              <p>{{ $t("help.url") }}</p>
            </div>
            <div>
              <p>{{ $t("help.tutorial") }}</p>
            </div>
          </div>
          <div class="form-bottom">
            <div>
              <img src="../assets/121.png" alt="" />
            </div>
            <div @click="toLink('https://www.gate.io/')">
              <p>Gate.Io</p>
            </div>
            <div @click="toLink('https://www.gate.io/cn/help/guide')">
              <p>{{ $t("help.tutorial") }}</p>
            </div>
          </div>
          <div class="form-bottom">
            <div>
              <img src="../assets/122.png" alt="" />
            </div>
            <div @click="toLink('https://www.huobi.com/')">
              <p>Huobi.Com</p>
            </div>
            <div @click="toLink('https://www.huobi.com/support/zh-cn/list/360000010372')">
              <p>{{ $t("help.tutorial") }}</p>
            </div>
          </div>
          <div class="form-bottom">
            <div>
              <img src="../assets/123.png" alt="" />
            </div>
            <div @click="toLink('https://Binance.Com/')">
              <p>Binance.Com</p>
            </div>
            <div @click="toLink('https://academy.binance.com/zh/articles/binance-beginner-s-guide')">
              <p>{{ $t("help.tutorial") }}</p>
            </div>
          </div>
          <div class="form-bottom">
            <div>
              <img src="../assets/124.png" alt="" />
            </div>
            <div @click="toLink('https://Okex.Com/')">
              <p>Okex.Com</p>
            </div>
            <div @click="toLink('https://www.okx.com/support/hc/zh-cn/sections/360000033031')">
              <p>{{ $t("help.tutorial") }}</p>
            </div>
          </div>
          <div class="form-bottom">
            <div>
              <img src="../assets/125.png" alt="" />
            </div>
            <div @click="toLink('https://Zb.Com/')">
              <p>Zb.Com</p>
            </div>
            <div @click="toLink('https://m.zb.com/cn/index/')">
              <p>{{ $t("help.tutorial") }}</p>
            </div>
          </div>
        </div>
        <div class="second-tips">
          {{ $t("help.vpn") }}
          <p @click="toLink('http://yicijiaoyu.com/')">[{{ $t("help.vpnurl") }}]</p>
          {{ $t("help.whirlwind") }}
          <p @click="toLink('https://www.xfjiasu.com/')">[{{ $t("help.whirlwind") }}]</p>
          ，{{ $t("help.can_login") }}
        </div>
      </div>
      <div class="steps-first" v-if="stepsStatus == '1'">
        <div class="register" style="color: #ffffff">
          {{ $t("help.register") }}
        </div>
        <div class="register">{{ $t("help.Already_have") }}</div>
        <div class="download">{{ $t("help.download") }}</div>
        <div class="com-title">{{ $t("help.com_title") }}</div>
        <div class="form-data">
          <div class="form-top">
            <div>
              <p>{{ $t("help.platform") }}</p>
            </div>
            <div>
              <p>{{ $t("help.url") }}</p>
            </div>
            <div>
              <p>{{ $t("help.tutorial") }}</p>
            </div>
          </div>
          <div class="form-bottom">
            <div>
              <img src="../assets/111.png" style="width:64px;height:16px" alt="" />
            </div>
            <div @click="toLink('https://www.token.im/')">
              <p>token.im</p>
            </div>
            <div @click="toGuide('1')">
              <p>{{ $t("help.tutorial") }}</p>
            </div>
          </div>
          <div class="form-bottom">
            <div>
              <img src="../assets/212.png" style="width:120%;height:90%" alt="" />
            </div>
            <div @click="toLink('https://trustwallet.com/')">
              <p>trustwallet.com</p>
            </div>
            <div @click="toGuide('2')">
              <p>{{ $t("help.tutorial") }}</p>
            </div>
          </div>
          <div class="form-bottom">
            <div>
              <img src="../assets/114.png" style="width:63px;height:12px" alt="" />
            </div>
            <div @click="toLink('https://www.tronlink.org/')">
              <p>tronlink.org</p>
            </div>
            <div @click="toGuide('3')">
              <p>{{ $t("help.tutorial") }}</p>
            </div>
          </div>
          <div class="form-bottom">
            <div>
              <img src="../assets/112.png" style="width:59px;height:12px" alt="" />
            </div>
            <div @click="toLink('https://www.ownbit.io/')">
              <p>ownbit.io</p>
            </div>
            <div @click="toGuide('4')">
              <p>{{ $t("help.tutorial") }}</p>
            </div>
          </div>

          <div class="form-bottom">
            <div>
              <img src="../assets/215.png" alt="" style="width:126px;height:32px;margin-left: -4px;" />
            </div>
            <div @click="toLink('https://www.bitpie.com/')">
              <p>Bitpie.Com</p>
            </div>
            <div @click="toGuide('5')">
              <p>{{ $t("help.tutorial") }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tabbar from '../components/tabbar.vue'
export default {
  components: {
    tabbar
  },
  data() {
    return {
      stepsStatus: '1',
      height: '' //屏幕高度
    }
  },
  //获取屏幕高度
  created() {
    let h = document.documentElement.clientHeight || document.body.clientHeight;
    if (h > 0) {
      this.height = h + 'px' //页面高度
    } else {
      this.height = "100vh"
    }
  },
  mounted() { },
  methods: {
    toGuide(item) {
      this.$emit('toGuide', item)
    },
    toLink(item) {
      this.$emit('toFriend', item)
    },
    changeActiveStatus(item) {
      if (item == '1') {
        this.$router.push('/luckyHash')
      } else if (item == '2') {
      } else if (item == '3') {
        if (!localStorage.getItem('token')) {
          this.$router.push('/index')
          return
        }
        this.$router.push('/spread')
      } else if (item == '4') {
      } else if (item == '5') {
        if (!localStorage.getItem('token')) {
          this.$router.push('/index')
          return
        }
        this.$router.push('/user')
      }
    },
    changeStepsStatus(item) {
      this.stepsStatus = item
    }
  }
}
</script>

<style lang="scss" scoped>
.help-help {
  width: 100vw;
  background: #0c0b0b;

  .help-steps {
    overflow-x: hidden;
    padding-bottom: 2rem;

    .second-tips {
      padding: 0.625rem 0.9375rem 0;
      font-size: 0.8125rem;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 1.4375rem;

      >p {
        display: inline;
        color: #ff693a;
      }
    }

    .steps-five {
      padding: 1.875rem 0.9375rem 0;

      .success {
        font-size: 0.75rem;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #999999;
        padding-bottom: 0.375rem;
      }

      .four-tips {
        padding: 0.9375rem;
        background: #161414;
        border-radius: 0.625rem;
        border: 1px solid #272727;

        .steps-three {
          >div:nth-child(1) {
            font-size: 0.8125rem;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 1.4375rem;
          }

          >div:nth-child(2) {
            font-size: 0.8125rem;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 1.4375rem;
          }

          >div:nth-child(3) {
            font-size: 0.6875rem;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            line-height: 1.4375rem;
          }
        }

        .steps-four {
          font-size: 0.8125rem;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #eedfb0;
          padding-top: 1.25rem;
          line-height: 1.4375rem;

          >p {
            display: inline-block;
            color: #ffc400;
          }
        }

        .login {
          height: 2.6875rem;
          background: linear-gradient(180deg, #ffdb67 0%, #f8c007 100%);
          border-radius: 1.375rem;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto;
          padding: 0 15px;

          >p {
            font-size: 0.9375rem;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #0c0b0b;
          }
        }
      }

      .tips {
        width: 100%;
        background: #161414;
        border-radius: 0.625rem;
        border: 1px solid #272727;

        >div {
          padding: 0.9375rem;
          font-size: 0.8125rem;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #eedfb0;
          line-height: 1.4375rem;
        }
      }
    }

    .steps-first {
      padding: 1.875rem 0.9375rem 0;

      .first-descript {
        >div:nth-child(1) {
          font-size: 0.8125rem;
          font-family: PingFang SC-Bold, PingFang SC;
          font-weight: bold;
          color: #999999;
          text-align: center;
          line-height: 1.45rem;
          padding-bottom: 1.75rem;
        }

        >div:nth-child(2) {
          font-size: 0.8125rem;
          font-family: PingFang SC-Bold, PingFang SC;
          font-weight: bold;
          color: #999999;
          text-align: center;
          line-height: 1.45rem;
          padding-bottom: 1.75rem;
        }

        >div:nth-child(3) {
          text-align: center;
          font-size: 1.1875rem;
          font-family: PingFang SC-Bold, PingFang SC;
          font-weight: bold;
          color: #999999;
          padding-bottom: 1.25rem;
        }

        >div:nth-child(4) {
          padding: 0 1.875rem;
          text-align: center;
          font-size: 0.8125rem;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #999999;
          line-height: 1.45rem;
        }

        >div:nth-child(5) {
          padding: 0 1.875rem;
          text-align: center;
          font-size: 0.8125rem;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #999999;
          line-height: 1.45rem;
        }

        >div:nth-child(6) {
          padding: 0 1.875rem;
          text-align: center;
          font-size: 0.8125rem;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #999999;
          padding-bottom: 1.25rem;
          white-space: nowrap;

          >p {
            display: inline;
            text-decoration: underline;
          }
        }

        >div:nth-child(7) {
          padding: 0 1.875rem;
          text-align: center;
          font-size: 0.8125rem;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #999999;
          padding-bottom: 1rem;
        }
      }

      .image-text {
        display: flex;
        padding: 0 1.875rem;
        flex-wrap: wrap;

        >div {
          width: 50%;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          padding-bottom: 1.25rem;

          >img {
            display: block;
            width: 2.4375rem;
            height: 2.4375rem;
          }

          >p {
            font-size: 0.8125rem;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #ffffff;
            padding-left: 0.375rem;
          }
        }
      }

      .nowLogin {
        padding: 0 1.875rem;
        padding-bottom: 1.875rem;
        margin-top: 1.25rem;

        >div {
          width: 100%;
          height: 2.6875rem;
          background: linear-gradient(180deg, #ffdb67 0%, #f8c007 100%);
          border-radius: 1.375rem;
          display: flex;
          align-items: center;
          justify-content: center;

          >p {
            font-size: 0.9375rem;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #0c0b0b;
          }
        }
      }

      .common-questions {
        padding: 0.9375rem;
        background: #161414;
        border-radius: 0.625rem;

        .questions-item {
          padding-bottom: 1.25rem;

          .item-top {
            font-size: 0.8125rem;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            padding-bottom: 0.625rem;
          }

          .special {
            display: flex;
            align-items: center;
            padding-bottom: 0.625rem;

            >img {
              display: block;
              width: 0.75rem;
              height: 0.75rem;
            }

            >p {
              display: block;
              color: #ff693a;
              font-size: 0.8125rem;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              padding-left: 0.625rem;
            }
          }

          .telegram {
            padding: 1.25rem 0 0.9375rem;

            >img {
              width: 2.6875rem;
              height: 2.6875rem;
            }

            >div {
              font-size: 0.8125rem;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #999999;
              padding-top: 0.625rem;
            }
          }

          .item-bottom {
            font-size: 0.8125rem;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 1.4375rem;

            >img {
              display: inline-block;
              width: 0.75rem;
              height: 0.75rem;
            }

            >p {
              display: inline;
              color: #ff693a;
            }
          }
        }

        .questions-title {
          font-size: 1rem;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffc400;
          padding-bottom: 0.9375rem;
        }
      }

      .reason {
        .why {
          font-size: 1rem;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          padding: 1.75rem 0 0;
          text-align: center;
        }

        .title-reason {
          font-size: 0.9375rem;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          text-align: center;
          padding: 0.625rem 0 0.9375rem;
        }

        .details-reason {
          font-size: 0.8125rem;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #999999;
          text-align: center;
          padding-bottom: 0.375rem;
        }

        .image {
          width: 100%;
          display: flex;
          justify-content: center;
          padding-top: 1.5625rem;

          >img {
            width: 3.9375rem;
            height: 3.9375rem;
            margin: 0 auto;
          }
        }
      }

      .register {
        font-size: 0.75rem;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #999999;
        padding-bottom: 0.9375rem;
      }

      .download {
        font-size: 0.875rem;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #ff693a;
        padding-bottom: 1.5625rem;
      }

      .com-title {
        font-size: 0.8125rem;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #999999;
        padding-bottom: 0.9375rem;
      }

      .form-data {
        width: 100%;
        background: #161414;
        border-radius: 0.625rem;
        border: 1px solid #272727;
        overflow: hidden;

        .form-bottom {
          display: flex;
          background: #110E31;
          width: 100%;
          height: 2.9375rem;
          border-top: 1px solid #272727;

          >div {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;

            >img {
              display: block;
              // width: 4.0625rem;
              height: 1.375rem;
            }

            >p {
              font-size: 0.875rem;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #999999;
            }
          }
        }

        .form-top {
          display: flex;
          width: 100%;
          height: 2.6875rem;
          background: #ffc400;
          border-radius: 0.625rem 0.625rem 0 0;

          >div {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;

            >p {
              font-size: 0.875rem;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #ffffff;
            }
          }
        }
      }
    }

    .steps-title {
      font-size: 1.125rem;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #f8c007;
      text-align: center;
      padding: 0.9375rem 0;
    }

    .steps-button {
      display: flex;
      align-items: center;
      justify-content: center;

      .steps-active {
        background: linear-gradient(180deg, #ffdb67 0%, #ffc400 100%);
        box-shadow: inset 0px 0.125rem 0.1875rem 0.0625rem rgba(255, 238, 184, 1);
      }

      >div {
        width: 2.1875rem;
        height: 2.1875rem;
        background: #efefef;
        box-shadow: inset 0px 0.125rem 0.1875rem 0.0625rem rgba(0, 0, 0, 0.4);
        border-radius: 0.3125rem;
        margin: 0 0.625rem;
        display: flex;
        align-items: center;
        justify-content: center;

        >p {
          font-size: 0.9375rem;
          font-family: PingFang SC-Bold, PingFang SC;
          font-weight: bold;
          color: #999999;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/help.vue